export default __webpack_public_path__ + "static/media/pot-with-gold.e208334d.png";